import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, browserLocalPersistence, setPersistence } from "firebase/auth";

// Firebase configuration
const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "empty",
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "empty",
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "empty",
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "empty",
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "empty",
    appId: import.meta.env.VITE_FIREBASE_APP_ID || "empty",
};

// Log config status (Safe since API key is public anyway, and helps debugging)
if (import.meta.env.DEV) {
    console.log("Firebase Init:", {
        projectId: firebaseConfig.projectId,
        hasApiKey: firebaseConfig.apiKey !== "empty"
    });
}

export const firebaseApp = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
export const firestore = getFirestore(firebaseApp);
export const auth = getAuth(firebaseApp);

// Set persistence once at module init (survives browser restart)
setPersistence(auth, browserLocalPersistence)
    .then(() => console.log("Auth persistence set to local"))
    .catch((error) => console.error("Persistence error:", error));
